import { DiscountOption } from '@order/orderTypes'
import { StateCreator } from 'zustand'

export type DiscountState = {
  discounts: DiscountOption[]
}

export type DiscountStateActions = {
  addDiscount: (discount: DiscountOption) => void
  removeDiscount: (discountId: string) => void
  updateDiscount: (discount: DiscountOption) => void
}

export const initialDiscountState = []

export const discountsSlice: StateCreator<
  DiscountStateActions & DiscountState,
  [['zustand/immer', never], never],
  [],
  DiscountStateActions
> = (set, get) => ({
  addDiscount: (discount) => {
    set((state) => ({
      discounts: [...state.discounts, discount],
    }))
  },
  updateDiscount: (discount) => {
    set((state) => ({
      discounts: state.discounts.map((d) =>
        d.id === discount.id ? discount : d
      ),
    }))
  },
  removeDiscount: (discountId) => {
    set((state) => ({
      discounts: state.discounts.filter((d) => d.id !== discountId),
    }))
  },
})
